import {
  isAmrAudioFile,
  isBinaryAudioDurationFormat,
  readBinaryAudioDuration,
} from '~/utils/audioDurationParser.js'

function readDurationFromMediaElement(file, type = 'video') {
  return new Promise((resolve, reject) => {
    if (typeof document === 'undefined') {
      reject(new Error('Media duration can only be checked in the browser.'))
      return
    }

    const element = document.createElement(type === 'video' ? 'video' : 'audio')
    element.preload = 'metadata'
    const objectUrl = URL.createObjectURL(file)

    const cleanup = () => {
      URL.revokeObjectURL(objectUrl)
    }

    element.onloadedmetadata = () => {
      cleanup()
      const duration = Number(element.duration)
      if (Number.isFinite(duration) && duration > 0 && duration !== Infinity) {
        resolve(duration)
        return
      }
      reject(new Error('Unable to read media metadata.'))
    }

    element.onerror = () => {
      cleanup()
      reject(new Error('Unable to read media metadata.'))
    }

    element.src = objectUrl
  })
}

/**
 * 读取本地媒体时长。
 * - AMR：文件头帧计数（浏览器几乎都不支持）
 * - 其它：audio/video 元素
 * @param {File|Blob} file
 * @param {'video'|'audio'} [type='video']
 * @returns {Promise<number>}
 */
export async function getMediaDuration(file, type = 'video') {
  if (!file) {
    throw new Error('file is required')
  }
  if (typeof document === 'undefined') {
    throw new Error('Media duration can only be checked in the browser.')
  }

  if (type === 'audio' && isAmrAudioFile(file)) {
    return readBinaryAudioDuration(file)
  }

  try {
    return await readDurationFromMediaElement(file, type)
  } catch (error) {
    if (type === 'audio' && isBinaryAudioDurationFormat(file)) {
      return readBinaryAudioDuration(file)
    }
    throw error
  }
}
